import type { TextStyleValue } from '@elfsight/configurator-contracts';

const BORDER_WIDTH_REGULAR = 1;
const BORDER_WIDTH_BOLD = 2;
const FONT_SIZE_THRESHOLD_REGULAR = 20;
const FONT_SIZE_THRESHOLD_BOLD = 14;

export function computeBorderWidth({ fontWeight, fontSize }: TextStyleValue) {
  const isRegularThick =
    fontWeight === 'normal' && fontSize >= FONT_SIZE_THRESHOLD_REGULAR;
  const isBoldThick =
    fontWeight === 'bold' && fontSize >= FONT_SIZE_THRESHOLD_BOLD;

  return isRegularThick || isBoldThick
    ? BORDER_WIDTH_BOLD
    : BORDER_WIDTH_REGULAR;
}
